

class BundleIngredients
extends HTMLElement {

    constructor() {
      super();
      this._ul = this.querySelector("ul");
      this._dynamicUpdate = this.dataset.dynamicUpdate == "true" ? true : false;
      this._onUpdateIngredientsListener = this._onUpdateIngredients.bind(this);
      this._type = this.getAttribute("data-type");
    }
    connectedCallback() {
      document.addEventListener("bundlePage:updateIngredients", this._onUpdateIngredientsListener);
    }
    disconnectedCallback() {
      document.removeEventListener("bundlePage:updateIngredients", this._onUpdateIngredientsListener);
    }
    _onUpdateIngredients(event) {
      if (this._dynamicUpdate) {
        if (this._type == "bundle-focus-ingredients") {
          const ingredientWrapper = this.querySelector(".bundle-focus-ingredients__list");
          let ingredientsHTML = "";

          event.detail.ingredients.forEach(ingredient => {
            ingredientsHTML += `<div class="bundle-focus-ingredient">
              <img src="${event.detail.ingredientImages[ingredient]}?width=100" alt="" width="100" height="100">
              <p class="h4 bfi_header">${ingredient}</p>`;
            if (event.detail.ingredientShortDescriptions[ingredient] != null) {
              ingredientsHTML += `<p class="bfi_short_desc text-xs"><b>${event.detail.ingredientShortDescriptions[ingredient]}</b></p>`
            }
            if (event.detail.ingredientDescriptions[ingredient] != null) {
              ingredientsHTML += `<p class="text-xxs">${event.detail.ingredientDescriptions[ingredient]}</p>`
            }
            ingredientsHTML += `</div>`;
          })

          ingredientWrapper.innerHTML = ingredientsHTML + ingredientWrapper.innerHTML;
        } else {
          this._ul.innerHTML = event.detail.ingredients.map(ingredient =>
            `<li class="bundle-ingredient">
              <img src="${event.detail.ingredientImages[ingredient]}">
              <span>${ingredient}</span>
            </li>`
          ).join("");
        }
      }
    }
}


window.customElements.define(
    'bundle-ingredients' ,
    BundleIngredients
)
